import { Database } from 'lucide-react'
import { useTranslation } from '@/i18n'
import { IntuiEmptyState } from '@/components/intueri/IntuiEmptyState'

/**
 * What a Retina-only tenant sees where the knowledge graph would be (Opening Cortex,
 * design §3): the layer is not owned, which is a different message from "not built yet".
 */
export default function RetinaOnlyEmptyState() {
  const { t } = useTranslation()
  return (
    <div className="flex h-full flex-col items-center justify-center px-6" data-testid="retina-only-empty-state">
      <IntuiEmptyState
        variant="no-data"
        icon={<Database className="size-4 text-foreground" />}
        title={t('knowledge_graph:retina_only.title', { defaultValue: 'Knowledge graph not included' })}
        description={t('knowledge_graph:retina_only.subtitle', {
          defaultValue:
            'This workspace has Retina (documents and extraction) but not UKG, the knowledge-graph layer. Documents are still ingested and searchable; ask your Intuigence contact to enable UKG to build and explore the graph.',
        })}
        className="w-[420px]"
      />
    </div>
  )
}
